module.exports = __webpack_public_path__ + "img/kyrgystan-min.30879c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countries/kyrgystan-min.png
// module id = QSK7
// module chunks = 1